import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mu-map-static',
  templateUrl: './mu-map-static.component.html',
  styleUrls: ['./mu-map-static.component.sass'],
})
export class MuMapStaticComponent {
  @Input() urlPath: string;

  constructor() {
    /** */
  }
}
